<template>
  <div class="user-center">
    <div class="container">
      <div class="sidebar">
        <div class="user-profile">
          <div class="avatar">
            <span class="avatar-text">{{ userInfo?.nickname?.charAt(0) || 'U' }}</span>
          </div>
          <h3 class="username">{{ userInfo?.nickname || '未登录' }}</h3>
          <p class="user-level">
            <span class="level-tag">普通会员</span>
          </p>
        </div>
        <nav class="user-nav">
          <ul>
            <li class="nav-item active" @click="activeTab = 'dashboard'">
              <span class="nav-icon">📊</span>
              <span>个人中心</span>
            </li>
            <li class="nav-item" @click="activeTab = 'checkin'">
              <span class="nav-icon">📅</span>
              <span>每日签到</span>
            </li>
            <li class="nav-item" @click="activeTab = 'payment'">
              <span class="nav-icon">💳</span>
              <span>充值中心</span>
            </li>
            <li class="nav-item" @click="activeTab = 'indicators'">
              <span class="nav-icon">📈</span>
              <span>我的指标</span>
            </li>
            <li class="nav-item" @click="activeTab = 'settings'">
              <span class="nav-icon">⚙️</span>
              <span>账户设置</span>
            </li>
            <li class="nav-item" @click="handleLogout">
              <span class="nav-icon">🚪</span>
              <span>退出登录</span>
            </li>
          </ul>
        </nav>
      </div>
      <div class="content">
        <!-- 个人中心 -->
        <div v-if="activeTab === 'dashboard'" class="dashboard">
          <div class="section">
            <h2>账户概览</h2>
            <div class="stats-grid">
              <div class="stat-card">
                <div class="stat-icon">💰</div>
                <div class="stat-info">
                <div class="stat-value">{{ userInfo?.points || 0 }}</div>
                <div class="stat-label">账户积分</div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon">🏆</div>
              <div class="stat-info">
                <div class="stat-value">{{ userInfo?.vipLevel || 0 }}</div>
                <div class="stat-label">VIP等级</div>
              </div>
              </div>
              <div class="stat-card">
                <div class="stat-icon">📅</div>
                <div class="stat-info">
                <div class="stat-value">{{ checkinStatus?.consecutiveDays || 0 }}</div>
                <div class="stat-label">连续签到</div>
              </div>
              </div>
              <div class="stat-card">
                <div class="stat-icon">📁</div>
                <div class="stat-info">
                  <div class="stat-value">0</div>
                  <div class="stat-label">我的指标</div>
                </div>
              </div>
            </div>
          </div>
          <div class="section">
            <h2>最近动态</h2>
            <div class="activity-list">
              <div class="activity-item">
                <div class="activity-icon">📅</div>
                <div class="activity-content">
                  <p>您已连续签到 <strong>3</strong> 天</p>
                  <span class="activity-time">今天 08:30</span>
                </div>
              </div>
              <div class="activity-item">
                <div class="activity-icon">📈</div>
                <div class="activity-content">
                  <p>下载了指标 <strong>妖股爆发</strong></p>
                  <span class="activity-time">昨天 14:20</span>
                </div>
              </div>
              <div class="activity-item">
                <div class="activity-icon">💳</div>
                <div class="activity-content">
                  <p>充值了 <strong>100</strong> 积分</p>
                  <span class="activity-time">3天前</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 每日签到 -->
        <div v-if="activeTab === 'checkin'" class="checkin-section">
          <h2>每日签到</h2>
          <div class="checkin-card">
            <div class="checkin-status" v-if="checkinStatus.hasCheckedIn">
              <div class="status-icon">✅</div>
              <h3>今日已签到</h3>
              <p>连续签到 {{ checkinStatus.consecutiveDays }} 天</p>
              <p class="checkin-reward">获得 <span class="reward-points">5</span> 积分奖励</p>
            </div>
            <div class="checkin-form" v-else>
              <div class="status-icon">📅</div>
              <h3>每日签到</h3>
              <p>签到可获得积分奖励，连续签到天数越多，奖励越丰厚</p>
              <button class="checkin-btn" @click="handleCheckIn" :disabled="isCheckingIn">
                {{ isCheckingIn ? '签到中...' : '立即签到' }}
              </button>
              <div class="checkin-rules">
                <h4>签到规则</h4>
                <ul>
                  <li>每日签到可获得 5 积分</li>
                  <li>连续签到 7 天额外获得 20 积分</li>
                  <li>连续签到 30 天额外获得 100 积分</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 充值中心 -->
        <div v-if="activeTab === 'payment'" class="payment-section">
          <h2>充值中心</h2>
          <div class="payment-options">
            <div class="payment-card" v-for="option in paymentOptions" :key="option.id" @click="selectedPayment = option">
              <div class="payment-amount">{{ option.amount }} 积分</div>
              <div class="payment-price">{{ option.price }} 元</div>
              <div class="payment-desc">{{ option.desc }}</div>
              <div class="payment-checkbox" :class="{ active: selectedPayment.id === option.id }">
                <span v-if="selectedPayment.id === option.id">✓</span>
              </div>
            </div>
          </div>
          <div class="payment-method">
            <h3>支付方式</h3>
            <div class="method-card active">
              <div class="method-icon">🔷</div>
              <div class="method-info">
                <h4>支付宝</h4>
                <p>扫码支付</p>
              </div>
            </div>
          </div>
          <div class="payment-actions">
            <button class="pay-btn" @click="handlePayment" :disabled="!selectedPayment">
              立即支付 {{ selectedPayment?.price || 0 }} 元
            </button>
          </div>
          <!-- 支付弹窗 -->
          <div class="payment-modal" v-if="showPaymentModal">
            <div class="modal-content">
              <h3>支付宝扫码支付</h3>
              <div class="qr-code">
                <div class="qr-placeholder">
                  <QRCode :text="alipayUrl" :size="200" />
                  <p class="qr-amount">金额：{{ selectedPayment?.price || 0 }} 元</p>
                </div>
              </div>
              <div class="modal-actions">
                <button class="modal-btn" @click="showPaymentModal = false">取消</button>
                <button class="modal-btn primary" @click="confirmPayment">已支付</button>
              </div>
            </div>
          </div>
          <!-- 充值成功弹窗 -->
          <div class="payment-modal" v-if="showSuccessModal">
            <div class="modal-content success-modal">
              <div class="success-icon">✓</div>
              <h3>充值成功</h3>
              <p>您已成功充值 {{ selectedPayment?.amount || 0 }} 积分</p>
              <div class="download-section">
                <h4>VIP专属下载</h4>
                <div class="download-links">
                  <a href="#" class="download-link" @click.prevent="downloadFile('indicator')">
                    <span class="link-icon">📊</span>
                    <span class="link-text">高级指标公式</span>
                    <span class="download-btn">下载</span>
                  </a>
                  <a href="#" class="download-link" @click.prevent="downloadFile('strategy')">
                    <span class="link-icon">📈</span>
                    <span class="link-text">交易策略模板</span>
                    <span class="download-btn">下载</span>
                  </a>
                  <a href="#" class="download-link" @click.prevent="downloadFile('tutorial')">
                    <span class="link-icon">📚</span>
                    <span class="link-text">VIP教程视频</span>
                    <span class="download-btn">下载</span>
                  </a>
                </div>
              </div>
              <div class="modal-actions">
                <button class="modal-btn primary" @click="showSuccessModal = false">关闭</button>
              </div>
            </div>
          </div>
        </div>

        <!-- 我的指标 -->
        <div v-if="activeTab === 'indicators'" class="indicators-section">
          <h2>我的指标</h2>
          <div class="empty-state">
            <div class="empty-icon">📁</div>
            <h3>暂无指标</h3>
            <p>您还没有下载过指标，去指标公式页面看看吧</p>
            <router-link to="/indicators" class="empty-btn">浏览指标</router-link>
          </div>
        </div>

        <!-- 账户设置 -->
        <div v-if="activeTab === 'settings'" class="settings-section">
          <h2>账户设置</h2>
          <form class="settings-form">
            <div class="form-item">
              <label>用户名</label>
              <input type="text" value="{{ userInfo?.username }}" disabled>
            </div>
            <div class="form-item">
              <label>昵称</label>
              <input type="text" v-model="userSettings.nickname">
            </div>
            <div class="form-item">
              <label>邮箱</label>
              <input type="email" v-model="userSettings.email">
            </div>
            <div class="form-item">
              <label>密码</label>
              <input type="password" v-model="userSettings.password" placeholder="请输入新密码">
            </div>
            <div class="form-actions">
              <button type="button" class="save-btn" @click="saveSettings">保存设置</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userStore from '../store/user'
import QRCode from '../components/QRCode.vue'

export default {
  name: 'UserCenterView',
  components: {
    QRCode
  },
  data() {
    return {
      activeTab: 'dashboard',
      userInfo: null,
      checkinStatus: {
        hasCheckedIn: false,
        consecutiveDays: 0,
        lastCheckInDate: null
      },
      isCheckingIn: false,
      paymentOptions: [
        { id: 1, amount: 100, price: 10, desc: '新手推荐' },
        { id: 2, amount: 500, price: 45, desc: '超值优惠' },
        { id: 3, amount: 1000, price: 80, desc: '最划算' }
      ],
      selectedPayment: { id: 1, amount: 100, price: 10, desc: '新手推荐' },
      showPaymentModal: false,
      showSuccessModal: false,
      alipayUrl: '',
      currentOrderNo: '',
      userSettings: {
        nickname: '',
        email: '',
        password: ''
      }
    }
  },
  mounted() {
    this.loadUserInfo()
    this.loadCheckInStatus()
  },
  methods: {
    loadUserInfo() {
      if (userStore.state.isLoggedIn) {
        this.userInfo = userStore.state.userInfo
        this.userSettings.nickname = this.userInfo.nickname
      }
    },
    loadCheckInStatus() {
      userStore.actions.getCheckInStatus().then(status => {
        this.checkinStatus = status
      })
    },
    async handleCheckIn() {
      this.isCheckingIn = true
      try {
        const status = await userStore.actions.checkIn()
        this.checkinStatus = status
        // 显示签到成功提示
        this.$message.success('签到成功，获得5积分')
      } catch (error) {
        console.error('签到失败:', error)
      } finally {
        this.isCheckingIn = false
      }
    },
    async handlePayment() {
      if (this.selectedPayment) {
        try {
          const result = await userStore.actions.createPaymentOrder(
            this.selectedPayment.price,
            '积分充值',
            `充值${this.selectedPayment.amount}积分`
          )
          
          if (result.success) {
            this.alipayUrl = result.qrCode
            this.currentOrderNo = result.orderNo
            this.showPaymentModal = true
          } else {
            this.$message.error('创建支付订单失败：' + result.message)
          }
        } catch (error) {
          console.error('创建支付订单失败:', error)
          this.$message.error('创建支付订单失败')
        }
      }
    },
    async confirmPayment() {
      try {
        // 检查支付状态
        const paymentResult = await userStore.actions.checkPaymentStatus(this.currentOrderNo)
        
        if (paymentResult.success) {
          // 更新用户积分
          await userStore.actions.addPoints(this.selectedPayment.amount)
          
          // 重新加载用户信息
          this.loadUserInfo()
          
          // 显示成功弹窗
          this.showPaymentModal = false
          this.showSuccessModal = true
        } else {
          this.$message.error('支付失败，请重试')
        }
      } catch (error) {
        console.error('检查支付状态失败:', error)
        this.$message.error('检查支付状态失败')
      }
    },
    downloadFile(type) {
      // 模拟文件下载
      const fileNames = {
        'indicator': '高级指标公式.zip',
        'strategy': '交易策略模板.zip',
        'tutorial': 'VIP教程视频.zip'
      }
      const fileName = fileNames[type] || '下载文件.zip'
      this.$message.success(`正在下载：${fileName}`)
      // 这里可以添加实际的下载逻辑
      console.log(`下载文件：${fileName}`)
    },
    saveSettings() {
      // 模拟保存设置
      setTimeout(() => {
        this.$message.success('设置保存成功')
      }, 500)
    },
    handleLogout() {
      userStore.actions.logout()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-center {
  padding: 30px 0;
  min-height: 80vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 280px;
  flex-shrink: 0;
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 30px;
}

.user-profile {
  text-align: center;
  margin-bottom: 40px;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #1890ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.avatar-text {
  font-size: 32px;
  font-weight: bold;
}

.username {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}

.user-level {
  margin: 0;
}

.level-tag {
  padding: 4px 12px;
  background-color: #e6f7ff;
  color: #1890ff;
  border-radius: 12px;
  font-size: 14px;
}

.user-nav {
  ul {
    list-style: none;
  }
  .nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 15px 20px;
    margin-bottom: 8px;
    background-color: #fff;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      background-color: #e6f7ff;
    }
    &.active {
      background-color: #1890ff;
      color: #fff;
    }
    .nav-icon {
      font-size: 18px;
    }
  }
}

.content {
  flex: 1;
  background-color: #fff;
  border-radius: 12px;
  padding: 40px;
}

.section {
  margin-bottom: 40px;
}

.section h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 25px;
  color: #333;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.stat-card {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 25px;
  display: flex;
  align-items: center;
  gap: 20px;
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }
}

.stat-icon {
  font-size: 32px;
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.activity-list {
  .activity-item {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-bottom: 15px;
  }
  .activity-icon {
    font-size: 20px;
    flex-shrink: 0;
  }
  .activity-content {
    flex: 1;
  }
  .activity-content p {
    margin-bottom: 8px;
    color: #333;
  }
  .activity-time {
    font-size: 12px;
    color: #999;
  }
}

.checkin-card {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
}

.status-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.checkin-card h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.checkin-card p {
  margin-bottom: 15px;
  color: #666;
}

.checkin-reward {
  margin-top: 20px;
  padding: 15px;
  background-color: #fff3cd;
  border-radius: 8px;
  color: #856404;
}

.reward-points {
  font-size: 18px;
  font-weight: bold;
  color: #ff6b6b;
}

.checkin-btn {
  padding: 12px 30px;
  background-color: #1890ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background-color: #40a9ff;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
}

.checkin-rules {
  margin-top: 30px;
  text-align: left;
  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #333;
  }
  ul {
    list-style: none;
    li {
      padding: 8px 0;
      color: #666;
      &::before {
        content: '•';
        color: #1890ff;
        font-weight: bold;
        margin-right: 10px;
      }
    }
  }
}

.payment-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.payment-card {
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  &:hover {
    border-color: #1890ff;
  }
  &.active {
    border-color: #1890ff;
    background-color: #f0f9ff;
  }
}

.payment-amount {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.payment-price {
  font-size: 18px;
  font-weight: 600;
  color: #ff6b6b;
  margin-bottom: 12px;
}

.payment-desc {
  font-size: 14px;
  color: #666;
}

.payment-checkbox {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 20px;
  height: 20px;
  border: 2px solid #e8e8e8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  &.active {
    background-color: #1890ff;
    border-color: #1890ff;
    color: #fff;
  }
}

.payment-method {
  margin-bottom: 40px;
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #333;
  }
}

.method-card {
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    border-color: #1890ff;
  }
  &.active {
    border-color: #1890ff;
    background-color: #f0f9ff;
  }
}

.method-icon {
  font-size: 32px;
}

.method-info h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
}

.method-info p {
  font-size: 14px;
  color: #666;
}

.payment-actions {
  text-align: center;
}

.pay-btn {
  padding: 15px 40px;
  background-color: #1890ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background-color: #40a9ff;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
}

.payment-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  border-radius: 12px;
  padding: 40px;
  width: 90%;
  max-width: 500px;
  text-align: center;
}

.modal-content h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #333;
}

.qr-code {
  margin-bottom: 30px;
}

.qr-placeholder {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
}

.qr-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.qr-placeholder p {
  margin-bottom: 10px;
  color: #666;
}

.qr-amount {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.modal-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.modal-btn {
  padding: 12px 30px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background-color: #fff;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background-color: #f5f5f5;
  }
  &.primary {
    background-color: #1890ff;
    color: #fff;
    border-color: #1890ff;
    &:hover {
      background-color: #40a9ff;
    }
  }
}

.success-modal {
  .success-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #52c41a;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    font-size: 40px;
  }
  h3 {
    color: #52c41a;
  }
}

.download-section {
  margin-top: 30px;
  text-align: left;
}

.download-section h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.download-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.download-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
  text-decoration: none;
  color: #333;
  transition: all 0.3s ease;
  &:hover {
    background-color: #e6f7ff;
  }
}

.link-icon {
  font-size: 20px;
}

.link-text {
  flex: 1;
}

.download-btn {
  padding: 6px 12px;
  background-color: #1890ff;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.empty-state h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.empty-state p {
  margin-bottom: 20px;
  color: #666;
}

.empty-btn {
  display: inline-block;
  padding: 12px 30px;
  background-color: #1890ff;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  &:hover {
    background-color: #40a9ff;
  }
}

.settings-form {
  max-width: 500px;
}

.settings-form .form-item {
  margin-bottom: 20px;
}

.settings-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.settings-form input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  &:focus {
    outline: none;
    border-color: #1890ff;
  }
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
}

.settings-form .form-actions {
  margin-top: 30px;
}

.save-btn {
  padding: 12px 30px;
  background-color: #1890ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background-color: #40a9ff;
  }
}
</style>
